// extracted by mini-css-extract-plugin
export var addButton = "_f1-0";
export var border = "_f1-8";
export var check = "_f1-h";
export var danger = "_f1-6";
export var dropdownContainer = "_f1-1";
export var editModalBody = "_f1-j";
export var footerContainer = "_f1-i";
export var fullWidth = "_f1-a";
export var hide = "_f1-9";
export var icon = "_f1-3";
export var input = "_f1-7";
export var inputFlex = "_f1-b";
export var inputWrapper = "_f1-c";
export var manualFocus = "_f1-5";
export var optionButton = "_f1-4";
export var pillWrapper = "_f1-e";
export var pointer = "_f1-2";
export var showOverflow = "_f1-f";
export var tagsFlex = "_f1-d";
export var xButton = "_f1-g";